"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_possibleConstructorReturn
});
const _assertThisInitializedMjs = /*#__PURE__*/ _interopRequireDefault(require("./_assert_this_initialized.js"));
const _typeOfMjs = /*#__PURE__*/ _interopRequireDefault(require("./_type_of.js"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && ((0, _typeOfMjs.default)(call) === "object" || typeof call === "function")) {
        return call;
    }
    return (0, _assertThisInitializedMjs.default)(self);
}
